"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionButtonDangerStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../appStylesBase");
var actionButtonStyles_1 = require("./actionButtonStyles");
var actionButtonDangerStyles = function () {
    return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    ", "\n    background-color: ", ";\n  "], ["\n    ", "\n    background-color: ", ";\n  "])), (0, actionButtonStyles_1.actionButtonStyles)(), (0, appStylesBase_1.appStylesBase)().backgroundColor.danger.medium);
};
exports.actionButtonDangerStyles = actionButtonDangerStyles;
var templateObject_1;
